/** Cor piscante de intervalo ainda dentro do TTL (`fase_cor_piscante_ms` + `fase_cor_piscante_desde`). */
export function corPiscanteIntervaloAtiva(fase, now = Date.now()) {
  if (!fase || fase.mod_piscante || !fase.fase_cor_piscante) return '';
  const ttl = parseInt(fase.fase_cor_piscante_ms, 10);
  if (ttl > 0) {
    const desde = parseInt(fase.fase_cor_piscante_desde, 10);
    if (!desde || now - desde > ttl) return '';
  }
  return fase.fase_cor_piscante;
}

function chaveFaseMapa(f) {
  return `${parseInt(f.controlador_id, 10)}:${parseInt(f.fase_id, 10)}`;
}

/** Preserva `fase_cor_piscante_desde` entre patches do mesmo intervalo piscante. */
export function aplicarTimestampsPiscante(incoming, anteriorLista) {
  const prevMap = new Map();
  for (const f of anteriorLista || []) {
    prevMap.set(chaveFaseMapa(f), f);
  }
  return (incoming || []).map(f => {
    if (!f.fase_cor_piscante) {
      const { fase_cor_piscante_desde, ...rest } = f;
      return rest;
    }
    const prev = prevMap.get(chaveFaseMapa(f));
    const stampKey = `${f.intervalo}|${f.fase_cor_piscante}|${f.fase_cor_piscante_ms || ''}`;
    const prevStampKey = prev
      ? `${prev.intervalo}|${prev.fase_cor_piscante}|${prev.fase_cor_piscante_ms || ''}`
      : '';
    const desde =
      prev && stampKey === prevStampKey && prev.fase_cor_piscante_desde
        ? prev.fase_cor_piscante_desde
        : Date.now();
    return { ...f, fase_cor_piscante_desde: desde };
  });
}

/** Fases pertencentes a um grupo físico. Exige `grupo_fisico_id` no payload. */
export function fasesDoGrupo(fases, grupoId) {
  const gid = parseInt(grupoId, 10);
  return (fases || []).filter(f => parseInt(f.grupo_fisico_id, 10) === gid);
}

/** Fases de todos os grupos, menos o informado. */
export function fasesDeOutrosGrupos(fases, grupoId) {
  const gid = parseInt(grupoId, 10);
  return (fases || []).filter(f => parseInt(f.grupo_fisico_id, 10) !== gid);
}

/** IDs únicos de controladores presentes em um array de fases. */
export function fasesControladorIds(fases) {
  const ids = new Set();
  for (const f of fases || []) {
    const id = parseInt(f.controlador_id, 10);
    if (id) ids.add(id);
  }
  return ids;
}

/** Snapshot full menor porque controladores foram removidos (não buffer parcial). */
export function isRemocaoLegitimaMapa(base, incoming) {
  const baseIds = fasesControladorIds(base);
  const inIds = fasesControladorIds(incoming);
  if (!baseIds.size || inIds.size >= baseIds.size) return false;
  for (const id of inIds) {
    if (!baseIds.has(id)) return false;
  }
  return true;
}

export function shouldAcceptMenorSnapshotFull(base, incoming, authoritative) {
  if (!base || !base.length || !incoming || incoming.length >= base.length) return true;
  if (authoritative) return true;
  return isRemocaoLegitimaMapa(base, incoming);
}
